import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Table Tools Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M21.25 3.1c1.1 0 2 .9 2 2v4H.75v-4c0-1.1.9-2 2-2zM8.25 9.1v11.8h-5.5c-1.1 0-2-.9-2-2V9.1zM.75 15.1h7.5M15.75 9.1h-7.5v11.8h7.5zM8.25 15.1h7.5M23.25 9.1v9.8c0 1.1-.9 2-2 2h-5.5V9.1zM15.75 15.1h7.5"
    }, null, -1)
  ])))
}
export default { render: render }